/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m31 16c0 8.2851543-6.7148457 15-15 15-8.28515432 0-15-6.7148457-15-15 0-8.28434395 6.71525268-15 15-15 8.2847473 0 15 6.71565605 15 15zm-2 0c0-7.17980134-5.8198491-13-13-13-7.18015092 0-13 5.82019866-13 13 0 7.1805848 5.81941518 13 13 13 7.1805848 0 13-5.8194152 13-13zm-9.3076923 5c0 .5522847-.4477153 1-1 1h-9.6923077c-.55228475 0-1-.4477153-1-1v-10c0-.5522847.44771525-1 1-1h9.6923077c.5522847 0 1 .4477153 1 1v2.0541652l2.7657554-1.7834732c.6654422-.4291047 1.5419369.048621 1.5419369.8404191v7.7777778c0 .7917981-.8764947 1.2695238-1.5419369.8404191l-2.7657554-1.7834732zm-2-3.8888889c0-.7917981.8764947-1.2695238 1.5419369-.8404191l2.7657554 1.7834732v-4.1083304l-2.7657554 1.7834732c-.6654422.4291047-1.5419369-.048621-1.5419369-.8404191v-2.8888889h-7.6923077v8h7.6923077z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;